import { io, Socket } from "socket.io-client";
import { App, Auth, IoEvent, EngineEvent, LogEvent, NodeEvent, ProjectEvent, PropertyEvent, RenderEvent, NodeLoadStateEvent, ErrorEvent, PortConnectionEvent } from "./peregrineFlowInterfaces";

// "undefined" means the URL will be computed from the `window.location` object
export const URL = process.env.NODE_ENV === 'production' ? "" : 'http://localhost:5000';

// Event sent when a guest tries to perform an authenticated-only operation
export interface AuthRequiredEvent {
    message: string;
    operation: string;
}

// Event sent on initial connection
export interface ConnectedEvent {
    is_guest: boolean;
}

interface ServerToClientEvents {
    connected: (data: ConnectedEvent) => void;
    setup: (data: App) => void;
    auth: (data: any) => void;
    logout: (data: any) => void;
    auth_required: (data: AuthRequiredEvent) => void; // when guest tries restricted operation
    render: (data: RenderEvent) => void; // all the time if data is send via a render node
    engine: (data: EngineEvent) => void; // we can get started stopped events
    node: (data: NodeEvent) => void; // if a node needs to be updated to to changes on ports or props
    "node.state": (data: NodeLoadStateEvent) => void;
    project: (data: ProjectEvent) => void; // if a project needs to be updated due to changes on nodes or edges
    io: (data: IoEvent) => void;
    log: (data: LogEvent) => void;
    error: (data: ErrorEvent) => void;
}

interface ClientToServerEvents {
    auth: (data: Auth) => void;
    logout: () => void;
    setup: () => void;
    node: (data: NodeEvent) => void;
    property: (data: PropertyEvent) => void;
    port_connect: (data: PortConnectionEvent) => void;
    port_disconnect: (data: PortConnectionEvent) => void;
    engine: (data: EngineEvent) => void;
    project: (data: ProjectEvent) => void;
    io: (data: IoEvent) => void;
}



// please note that the types are reversed
export const socket: Socket<ServerToClientEvents, ClientToServerEvents> = io(URL, { transports: ["websocket"], upgrade: false });
